var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: _vm.isSubtable ? "pigean-subtable" : "",
      attrs: { id: "pigean-gene" },
    },
    [
      _vm.tableData.length > 0
        ? _c(
            "div",
            [
              !_vm.isSubtable
                ? _c(
                    "div",
                    { staticClass: "text-right mb-2" },
                    [
                      _c("data-download", {
                        attrs: { data: _vm.probData, filename: "pigean_gene" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", {
                staticClass: "table-total-rows",
                domProps: { innerHTML: _vm._s("Total rows: " + _vm.rows) },
              }),
              _c("b-table", {
                attrs: {
                  hover: _vm.isSubtable,
                  small: "",
                  responsive: "",
                  items: _vm.tableData,
                  fields: _vm.probFields,
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  "sort-by": _vm.sortBy,
                  "sort-desc": true,
                  "sort-null-last": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(label)",
                      fn: function (r) {
                        return [
                          !!r.item.label
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      r.item.label.length > 50
                                        ? `${r.item.label.slice(0, 50)}...`
                                        : r.item.label
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "cell(gene)",
                      fn: function (r) {
                        return [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `/cvdi_pigean/gene.html?gene=${r.item.gene}${_vm.suffix}`,
                              },
                            },
                            [_vm._v(" " + _vm._s(r.item.gene) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(phenotypeDesc)",
                      fn: function (r) {
                        return [
                          !!_vm.phenotypeMap[r.item.phenotype]
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: `/cvdi_pigean/phenotype.html?phenotype=${r.item.phenotype}${_vm.suffix}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(r.item.phenotypeDesc) + " "
                                  ),
                                ]
                              )
                            : _c("span", [_vm._v(_vm._s(r.item.phenotype))]),
                        ]
                      },
                    },
                    {
                      key: "cell(gene_set)",
                      fn: function (r) {
                        return [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `/cvdi_pigean/geneset.html?geneset=${r.item.gene_set}${_vm.suffix}`,
                              },
                            },
                            [_vm._v(" " + _vm._s(r.item.gene_set) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(top_gene_sets)",
                      fn: function (r) {
                        return [
                          _c("div", { staticClass: "wrapped-cell-content" }, [
                            r.item.top_gene_sets
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(r.item.top_gene_sets) + " "
                                  ),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(top_genes)",
                      fn: function (r) {
                        return [
                          _c("div", { staticClass: "wrapped-cell-content" }, [
                            r.item.top_genes
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(r.item.top_genes) + " "),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(expand)",
                      fn: function (row) {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.showDetails(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(row.detailsShowing ? "Hide" : "Show") +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "row-details",
                      fn: function (row) {
                        return [
                          _vm.subtableData[_vm.subtableKey(row.item)] &&
                          _vm.subtableData[_vm.subtableKey(row.item)].length > 0
                            ? _c("cvdi-pigean-table", {
                                attrs: {
                                  pigeanData:
                                    _vm.subtableData[_vm.subtableKey(row.item)],
                                  config: { fields: _vm.config.subtableFields },
                                  isSubtable: true,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2672269353
                ),
              }),
              _c("b-pagination", {
                staticClass: "pagination-sm justify-content-center",
                attrs: {
                  "total-rows": _vm.tableData.length,
                  "per-page": _vm.perPage,
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "b-alert",
                {
                  staticClass: "text-center",
                  attrs: { show: "", variant: "warning" },
                },
                [
                  _c("b-icon", { attrs: { icon: "exclamation-triangle" } }),
                  _vm._v(" No data available for this query. "),
                ],
                1
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }